import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout rỗng — gom trang chính (boi-live.index.tsx) và chi tiết lịch sử
 * (boi-live.$sessionId.tsx) dưới tiền tố /boi-live (mirror pattern se-duyen). */
export const Route = createFileRoute("/_authenticated/boi-live")({
  component: () => <Outlet />,
});
